import { Directive, HostListener, Input } from '@angular/core';
import { CalendarEvent } from '../models';
import { CalendarExportService } from '../services';

@Directive({
    selector: '[exportCalendar]',
    standalone: false
})
export class ExportCalendarButtonDirective {

  @Input() exportCalendar!: CalendarEvent;

  constructor(private readonly calendarExportService: CalendarExportService) { }

  @HostListener('click') public openDialog() {
    this.calendarExportService.openCalendarExport(this.exportCalendar);
  }
}

